export const exportConfigConstants = {
    FETCH_CONFIGS_REQUEST: 'FETCH_CONFIGS_REQUEST',
    FETCH_CONFIGS_SUCCESS: 'FETCH_CONFIGS_SUCCESS',
    FETCH_CONFIGS_FAILURE: 'FETCH_CONFIGS_FAILURE',

    CREATE_CONFIG_REQUEST: 'CREATE_CONFIG_REQUEST',
    CREATE_CONFIG_SUCCESS: 'CREATE_CONFIG_SUCCESS',
    CREATE_CONFIG_FAILURE: 'CREATE_CONFIG_FAILURE',

    UPDATE_CONFIG_REQUEST: 'UPDATE_CONFIG_REQUEST',
    UPDATE_CONFIG_SUCCESS: 'UPDATE_CONFIG_SUCCESS',
    UPDATE_CONFIG_FAILURE: 'UPDATE_CONFIG_FAILURE',

    DELETE_CONFIG_REQUEST: 'DELETE_CONFIG_REQUEST',
    DELETE_CONFIG_SUCCESS: 'DELETE_CONFIG_SUCCESS',
    DELETE_CONFIG_FAILURE: 'DELETE_CONFIG_FAILURE',
};
